import {
  AdornedInput,
  Adornment,
  Checkbox,
  FormField,
  FormHelp,
  Heading,
  IconCalendarOutline,
  Label,
  LabeledControl,
} from '@zillow/constellation';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { today } from '../../../../utils/formatters';
import { validateDate } from '../../../../utils/validation';
import { FIELD_IDS } from '../../../../constants/wizard';
import { DatePickerInputMemoized } from '../../../DatePicker';

export function MoveInDateStep() {
  const { getValues, setValue } = useFormContext();
  const isMoveInFlexible = getValues(FIELD_IDS.MOVE_IN_FLEXIBLE);

  useEffect(() => {
    if (isMoveInFlexible === null) {
      setValue(FIELD_IDS.MOVE_IN_FLEXIBLE, false);
    }
  }, []);

  return (
    <>
      <Controller
        name={FIELD_IDS.MOVE_IN_DATE}
        rules={{
          required: 'Requested move-in date is required',
          validate: (v) =>
            validateDate(v, {
              inTheFuture: true,
            }),
        }}
        render={({ field, fieldState: { error, invalid } }) => (
          <FormField
            label={
              <Heading level={4} as="h2" marginBottom="sm" fontFamily="serif">
                When do you want to move into your new home?
              </Heading>
            }
            description={error && <FormHelp>{error?.message}</FormHelp>}
            error={invalid}
          >
            <AdornedInput
              input={<DatePickerInputMemoized {...field} minDate={today()} />}
              rightAdornment={
                <Adornment>
                  <IconCalendarOutline size="sm" />
                </Adornment>
              }
            />
          </FormField>
        )}
      />
      <Controller
        name={FIELD_IDS.MOVE_IN_FLEXIBLE}
        render={({ field: { onChange, value, onBlur } }) => (
          <LabeledControl
            label={<Label>I’m flexible with my move-in date</Label>}
            control={<Checkbox onChange={onChange} name={FIELD_IDS.MOVE_IN_FLEXIBLE} checked={value} onBlur={onBlur} />}
          />
        )}
      />
    </>
  );
}
